export const AUDIO = 'audio';
export const TEXT = 'text';
export const IMAGE = 'image';

// Tagging is our own type.
export const TAGGING = 'tagging';



// WEBPACK FOOTER //
// ./src/constants/mimeTypes.js